






import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CONTRACTS, WindowsServiceContract } from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { PlannedOperation } from '@/dto';

/*
 * Данный компонент является временным, и его необходимо целиком переделать при следующем реюзе.
 */

@Component
export default class Consist extends Vue {
    @Prop({ type: String, required: true }) public title!: string;
    @Prop({ type: Boolean, required: false }) public flow?: boolean;
    @Prop({ type: Boolean, required: false }) public new?: boolean;
    @Prop({ type: Object, required: false }) public operation?: PlannedOperation;

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;

    public open(): void {
        const method = this.new
            ? this._windowsService!.open
            : this._windowsService!.update;

        method.call(
            this._windowsService,
            'planned-operations-detail-page',
            {
                operationId: this.operationId,
                flow: this.flow,
                operation: this.operation
            }
        );
    }

    private get operationId() {
        return this.operation?.id;
    }
}
